$(window).load(function() {
    var $scroll_to_me = $('#scroll-to-me'),
        $form_errors = $('.form-errors');

    if ($scroll_to_me.length == 1) {
        theOffset = $scroll_to_me.offset();
        $('html, body').animate({
            scrollTop: theOffset.top
        }, 2000);
    } else if ($form_errors.length == 1) {
        $('html, body').animate({
            scrollTop: $form_errors.offset().top
        }, 200);
    }
});

$(function() {
    'use strict';

    //------------------------------------------------------------------------------------------------------------------
    // @ vars
    var $to_top = $('.store-locator-to-top'),
        $window = $(window),
        theOffset;

    //------------------------------------------------------------------------------------------------------------------
    // @ initialisation
    $('.video-thumb-body').matchHeight();
    $('.site-content a[href^=http]').attr({
        target: '_blank',
        rel: 'nofollow'
    });

    //------------------------------------------------------------------------------------------------------------------
    // events
    $('.prevent-default').on('click', function(e) {
        e.preventDefault();
    });

    $window.scroll(function() {
        if ($window.scrollTop() > 1000) {
            $to_top.css('left', '10px');
        } else {
            $to_top.css('left', '-500px');
        }
    });

    $(document).on('click', '.store-locator-to-top', function(e) {
        e.preventDefault();
        $window.scrollTop(0);
    });




    $('.slide-contents a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var href = $(this).attr('href');
        window.location.href = href;
    });

    $('.slider-slide-tpol-contents a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var href = $(this).attr('href');
        window.location.href = href;
    });

    $('.module-slider-slide a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var href = $(this).attr('href');
        window.location.href = href;
    });


});
